import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {useLocation} from 'react-router';
import {Container, useTheme} from '@mui/system';
import {Grid, useMediaQuery} from '@mui/material';
import {StyledNavLink} from "./StyledNavLink";
import {DrawerMenu} from "./DrawerMenu";
import {APP_BAR_COLOR, THEME_FONT_COLOR} from "../../App";
import BizLogo from "../../images/fulllogo_transparent_nobuffer.svg";

function MainMenu(props) {
  const currentLocation = useLocation()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
      <AppBar sx={{backgroundColor: APP_BAR_COLOR, color: THEME_FONT_COLOR}} position='static'>
        <Container sx={{marginLeft: 0}} maxWidth={'100%'}>
        <Toolbar>
          {isMobile ? (<DrawerMenu />)
          : (
        <Grid container direction={'row'} justifyContent={'space-between'}>
          <Grid container size={{xs: 1, sm: 1.5, md: 2}}>
            <Grid alignItems={'flex-start'} marginTop={2}>
              <img alt={''} src={BizLogo} width={'75%'} height={'75%'}/>
            </Grid>
            <Grid/>
          </Grid>
          <Grid container size={{md: 10}}>
            <Grid size={{xs: 1, sm: 1.5, md: 1.5}}>
              <StyledNavLink className={`${currentLocation.pathname === '/' ? 'active' : undefined}`} to={'/'}>Home</StyledNavLink>
            </Grid>
            <Grid size={{xs: 1, sm: 1.5, md: 1.5}}>
              <StyledNavLink className={`${currentLocation.pathname === '/drops' ? 'active' : undefined}`} to={'/drops'}>Drops</StyledNavLink>
            </Grid>
            <Grid size={{xs: 1, sm: 1.5, md: 1.5}}>
              <StyledNavLink className={`${currentLocation.pathname === '/calendar' ? 'active' : undefined}`} to={'/calendar'}>Calendar</StyledNavLink>
            </Grid>
            <Grid size={{xs: 1, sm: 1.5, md: 1.5}}>
              <StyledNavLink className={`${currentLocation.pathname === '/menu' ? 'active' : undefined}`} to={'/menu'}>Menu</StyledNavLink>
            </Grid>
            <Grid size={{xs: 1, sm: 1.5, md: 1.5}}>
              <StyledNavLink className={`${currentLocation.pathname === '/contact' ? 'active' : undefined}`} to={'/contact'}>Contact</StyledNavLink>
            </Grid>
            <Grid size={{xs: 1, sm: 1.5, md: 1.5}}>
              <StyledNavLink className={`${currentLocation.pathname === '/about' ? 'active' : undefined}`} to={'/about'}>About</StyledNavLink>
            </Grid>
          </Grid>
        </Grid>
        )}
        </Toolbar>
        </Container>
      </AppBar>
  )
}

export default MainMenu;
